import { Component, Input, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {SurveryEvaluationService} from './survery-evaluation.service';

@Component({
    selector: 'app-survey-thirtyeighty',
    templateUrl: './survey-thirtyeighty.component.html',
    styleUrls: ['./survey-thirtyeighty.component.css'],
    standalone: false
})
export class SurveyThirtyeightyComponent implements OnInit {
  surveyNo: string;
  title: string = "Household Goods TSP Evaluation Survey (GSA Form 3080)";
  @Input() externalTitle;
  constructor(private router: Router, private surveyService: SurveryEvaluationService) { }

  ngOnInit() {
    if(this.externalTitle){
      this.title = this.externalTitle;
    }
    window.scroll(0, 0);
  }

  /**
   * @description initiate survey with empty survey number.
   */
  initiateSurvey() {
    this.surveyService.setSurveyNo(null);
    this.router.navigate(['/evaluationForm']);
  }
  /**
   * @description initiate survey with entered survey number.
   */
  continueSurvey() {
    this.surveyService.setSurveyNo(this.surveyNo);
    this.router.navigate(['/evaluationForm'],  { queryParams: { surveyNo: this.surveyNo } });
  }

}
